import autocompleteCompanyInput from './autocompleteCompanyInput';

const input = document.querySelector('input[name="company_name"]');
const inputId = document.querySelector('input[name="company_id"]');

if (input && inputId) {
  autocompleteCompanyInput(input, inputId);

  input.addEventListener('keydown', function(e) {
    if( ( e.keyCode >= 48 && e.keyCode <= 90 ) || e.keyCode == 8 || e.keyCode == 46 ) {
      inputId.value = '';
    }
  });
}
